<template>
    <v-card>
        <v-card-title>What is the Don't Miss Score?</v-card-title>
        <v-card-text>
            The Don't Miss Score is a rating that tells you how exciting a game
            is.

            <v-row
                dense
                v-for="dmsRating in dmsRatings"
                :key="dmsRating.end"
                align="center"
                class="mt-4"
            >
                <v-col cols="auto">
                    <v-btn
                        fab
                        :color="dmsRating.color"
                        class="font-weight-bold text-h5"
                    >
                        {{ dmsRating.start }}
                    </v-btn>
                </v-col>
                <v-col cols="auto" class="text-h6"> to </v-col>
                <v-col cols="auto">
                    <v-btn
                        fab
                        :color="dmsRating.color"
                        class="font-weight-bold text-h5"
                    >
                        {{ dmsRating.end }}
                    </v-btn>
                </v-col>
                <v-col class="text-h6">
                    {{ dmsRating.text }}
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn @click="$emit('done')"> Close </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "HypeExplainer",
    data() {
        return {
            dmsRatings: [
                {
                    start: 85,
                    end: 100,
                    color: "dmsGreat",
                    text: "Great Game",
                },
                {
                    start: 65,
                    end: 84,
                    color: "dmsGood",
                    text: "Good Game",
                },
                {
                    start: 40,
                    end: 64,
                    color: "dmsOk",
                    text: "OK Game",
                },
                {
                    start: 0,
                    end: 39,
                    color: "dmsDull",
                    text: "Dull Game",
                },
            ],
        };
    },
};
</script>
